import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';

import Alert from 'react-s-alert';

export default Alert;
